
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-mieten-firmenfeier",
      function () {
        return require("private-next-pages/fotobox-mieten-firmenfeier.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-mieten-firmenfeier"])
      });
    }
  